import { create } from 'zustand';

export type WorkspaceRole = "customer" | "broker" | "admin" | "viewer" | "ops" | "finance";

export type User = {
    id: string;
    // `id` is the HubSpot owner id; databaseId is the `user` table id that
    // offer.broker_id / booking.broker_id reference. Use databaseId for broker matching.
    databaseId?: number | null;
    email: string;
    firstName: string;
    lastName: string;
    roleIds: string[];
    superAdmin: boolean;
    // Workspace role from the DB user row. Optional: sessions cached before the
    // role rollout don't carry it — use workspaceRole() rather than reading raw.
    role?: WorkspaceRole | null;
}

export type UserStore = {
    user: User | null;
    setUser: (user: User | null) => void;
}

export const useUserStore = create<UserStore>(set => ({
    user: null,
    setUser: user => set({ user })
}))

export const getUserStore = () => useUserStore.getState();

export function userInitials(user?: User) {
    if (!user) return '';
    return user.firstName[0] + user.lastName[0];
}

export function userFullName(user: User) {
    if (!user) return '';
    return `${user.firstName} ${user.lastName}`;
}

/** Effective workspace role. superAdmin outranks any DB role — the legacy
 *  onboarding flow flipped everyone (including admins) to 'broker', which
 *  otherwise hides the ops/finance surfaces from the people who run them.
 *  Pre-rollout cached sessions (no role) fall back to broker. */
export function workspaceRole(user?: User | null): WorkspaceRole {
    if (!user) return 'customer';
    if (user.superAdmin) return 'admin';
    if (user.role && user.role !== 'customer') return user.role;
    return 'broker';
}